import React from 'react'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { Box } from '@mui/material'
import PlaylistAddCheck from '@mui/icons-material/PlaylistAddCheck'

import TooltipComponent from '@professocial/professocialFormComponents/FormComponents/TooltipComponent'

interface IACheckedIconProps {
  value?: boolean
  icon?: 'commitmentsConfirmed' | 'finishedQuiz' | 'finishedWizard'
  title?: string
}

const TableIcon: React.FC<IACheckedIconProps> = (props) => {
  const value = props.value

  if (value) {
    return (
      <TooltipComponent
        title={props.title as any} aria-label={props.title} child={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {props.icon === 'commitmentsConfirmed' ? <PlaylistAddCheck />
              : props.icon === 'finishedQuiz'
                ? <AssignmentIndIcon />
                : <AssignmentIcon />}
          </Box>
        }
      />
    )
  } else if (!value) {
    return (
      <TooltipComponent
        title={props.title as any} aria-label={props.title} child={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {props.icon === 'commitmentsConfirmed'
              ? <PlaylistAddCheck color='disabled' />
              : props.icon === 'finishedQuiz'
                ? <AssignmentIndIcon color='disabled' />
                : <AssignmentIcon color='disabled' />}
          </Box>
        }
      />
    )
  }
  return null
}

export default TableIcon
